import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { Row } from 'react-styled-flexboxgrid';
import { FormItem } from './FormItem';

var FormRow = function FormRow(props) {
  return /*#__PURE__*/React.createElement(Row, null, props.row.map(function (item, index) {
    return /*#__PURE__*/React.createElement(FormItem, _extends({
      key: index
    }, props, item));
  }));
};

export { FormRow };